import BaseModel from '../../base/base_model';
import { IOverlayData } from './overlay_manager_service_interface';

export interface IQueueModel {
    queueList: IOverlayData[];
    queue(item: IOverlayData): number;
    getFirst(): IOverlayData;
    dequeue(): IOverlayData;
    size(): number;
    isEmpty(): boolean;
    clear(): void;
}

class QueueModel extends BaseModel implements IQueueModel{

    static CLASS: string = 'QueueModel';
    public queueList: IOverlayData[] = [];

    init() {}

    //Queue item, adds it to the list. Also performs a sorting based on item priority. Returns index of the item in the list
    queue(item: IOverlayData): number {
        let idx = 0;
        if (this.isEmpty()) {
            this.queueList.push(item);

            return idx;
        }

        idx++;
        // sorts the items by priority.
        while (this.size() > idx) {
            const current = this.queueList[idx];
            if (current.priority > item.priority) {
                break;
            }

            idx++;
        }

        this.queueList.splice(idx, 0, item);

        this.logger.info('item: ' + item.toString() + ' insert in ' + idx);

        return idx;
    }


    /**
     * Returns the first item from the queue.
     *
     *
     * @returns {Object} Item, the first in the queue.
     */
    getFirst(): IOverlayData {
        return this.queueList[0];
    }


    /**
     * Dequeue the queue
     *
     * @returns {MessageManagerModel} this, for chaining, if needed.
     */
    dequeue(): IOverlayData {
        return this.queueList.shift();
    }


    size(): number {
        return this.queueList.length;
    }

    //Verifies whether the list is empty
    isEmpty(): boolean {
        return 0 === this.size();
    }

    //Clear the queueList
    clear(): void {
        this.queueList = [];
    }
}

export default QueueModel;